import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { breadcrumbSlot } from "@redotech/redo-web/breadcrumb";
import { TranslatedBreadcrumbLayout } from "../return/returns-breadcrumb-label";

const overviewBreadcrumb = breadcrumbSlot();

export const overviewRoutes: PermissionedRouteObject[] = [
  {
    element: (
      <TranslatedBreadcrumbLayout
        breadcrumb={overviewBreadcrumb}
        getLabel={(t) => t("Overview")}
      />
    ),
    handle: { breadcrumb: overviewBreadcrumb },
    children: [
      {
        index: true,
        lazy: async () => {
          const { OverviewPage } = await import("./overview-page");
          return { Component: OverviewPage };
        },
      },
    ],
  },
];
